import { ref, onMounted, onUnmounted, watch } from 'vue';

/**
 * 监听元素是否在可视区域内的 hook
 * @param options IntersectionObserver 配置选项
 * @returns 包含元素引用和是否在可视区域的状态
 */
export const useIntersectionObserver = (options: IntersectionObserverInit = {}) => {
  const targetRef = ref<HTMLElement | null>(null);
  const isIntersecting = ref(false);
  let observer: IntersectionObserver | null = null;

  // 创建观察器函数
  const initObserver = () => {
    // 先清理之前的观察器
    if (observer) {
      // console.log('disconnect');
      observer.disconnect();
      // return;
    }

    // 检查 IntersectionObserver 是否可用
    if (!('IntersectionObserver' in window)) {
      console.warn('IntersectionObserver is not supported in this browser');
      return;
    }

    // 创建新的观察器
    observer = new IntersectionObserver((entries) => {
      const entry = entries[0];
      isIntersecting.value = entry.isIntersecting;
      // console.log('观察到元素状态变化:', entry.isIntersecting);
    }, {
      threshold: 0.1, // 默认阈值
      rootMargin: '0px 0px 0px 0px', // 默认边距
      ...options,
    });

    // 当元素可用时开始观察
    if (targetRef.value) {
      observer.observe(targetRef.value);
      // console.log('开始观察元素:', targetRef.value);
    }
  };

  // 监听 targetRef 变化，重新初始化观察器
  watch(targetRef, (newValue) => {
    if (newValue) {
      initObserver();
    }
  });

//   onMounted(() => {
//     // 初始化观察器
//     // targetRef.value && initObserver();
//   });

  onUnmounted(() => {
    // 清理观察器
    if (observer) {
      observer.disconnect();
    }
  });

  return {
    targetRef,
    isIntersecting,
    disconnect: () => {
      if (observer) {
        observer.disconnect();
      }
    },
  };
};
